import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import ordersService from '../../services/orders';

import {
  SHIPPING_INFO_STEP,
} from '../../blocks/Checkout/SteppedCheckout/constants';

import { placeOrder } from './index.migrated';
import { convertToBuilderNotation } from '../../utils';

export { placeOrder };

export const getOrder = createAsyncThunk('order/getOrder', async (orderId) =>
  ordersService.getOrder(orderId),
);

export const removeError = createAction('removeError');
export const addError = createAction('addError');
export const setStatus = createAction('order/setStatus');
export const setCurrentStep = createAction('setCurrentStep');
export const setEditingStep = createAction('setEditingStep');

export const orderSlice = createSlice({
  name: 'order',
  initialState: {
    status: 'idle',
    errorCode: undefined,
    errorMessage: undefined,
    currentStep: SHIPPING_INFO_STEP,
    editingStep: undefined,
  },
  reducers: {},
  extraReducers: convertToBuilderNotation({
    [placeOrder.pending]: (state) => ({
      ...state,
      errorCode: undefined,
      errorBlock: undefined,
      status: 'loading',
    }),
    [placeOrder.fulfilled]: (state, action) => ({
      ...state,
      errorCode: undefined,
      errorBlock: undefined,
      ...action.payload,
      status: 'succeeded',
    }),
    [placeOrder.rejected]: (state, action) => ({
      ...state,
      errorCode: action.payload.errorCode,
      errorMessage: action.payload.errorDetails,
      errorBlock: action.payload.errorBlock,
      status: 'failed',
    }),
    [getOrder.pending]: (state) => ({
      ...state,
      errorCode: undefined,
      status: 'loading',
    }),
    [getOrder.fulfilled]: (state, action) => ({
      ...state,
      ...action.payload,
      status: 'succeeded',
    }),
    [getOrder.rejected]: (state, payload) => ({
      ...state,
      errorCode: payload.error.message,
      status: 'failed',
    }),
    removeError: (state) => ({
      ...state,
      errorCode: undefined,
      errorBlock: undefined,
    }),
    addError: (state, payload) => ({
      ...state,
      errorBlock: payload.errorBlock,
      errorCode: payload.errorCode,
    }),
    setStatus: (state, payload) => ({
      ...state,
      status: payload.status,
    }),
    setCurrentStep: (state, payload) => ({
      ...state,
      currentStep: payload.value,
    }),
    setEditingStep: (state, payload) => ({
      ...state,
      editingStep: payload.value,
    }),
  }),
});

export default orderSlice.reducer;
